import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { api } from "@/lib/api";

export default function useAdminApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, extra = {}) => {
      const token = await getToken();
      const res = await api.request({ method, url, data, headers: { Authorization: `Bearer ${token}` }, ...extra });
      return res.data;
    },
    [getToken]
  );
}
